import { fmtDate, fmtMoney } from "./utils";

const th = "px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-ink/45";
const td = "px-4 py-3 text-sm text-ink/85";

const campaign = (l) =>
  [l.utm_source, l.utm_medium, l.utm_campaign].filter(Boolean).join(" / ") || "—";

export const LeadsTable = ({ leads }) => (
  <section data-testid="leads-section" className="rounded-2xl border border-ink/10 bg-surface">
    <div className="border-b border-ink/10 px-5 py-4">
      <h2 className="text-base font-bold text-ink">Leads</h2>
      <p className="text-xs text-ink/45">Every verified savings review request, newest first</p>
    </div>
    <div className="overflow-x-auto">
      <table data-testid="leads-table" className="min-w-full">
        <thead>
          <tr className="border-b border-ink/5">
            <th className={th}>Date</th>
            <th className={th}>Name</th>
            <th className={th}>Business</th>
            <th className={th}>Email</th>
            <th className={th}>Phone</th>
            <th className={th}>Volume</th>
            <th className={th}>Campaign</th>
            <th className={th}>Source</th>
          </tr>
        </thead>
        <tbody>
          {leads.map((l, i) => (
            <tr key={l.id || i} data-testid={`lead-row-${i}`} className="border-t border-ink/5 transition-colors hover:bg-elevated/40">
              <td className={`${td} whitespace-nowrap text-ink/55`}>{fmtDate(l.created_at)}</td>
              <td className={`${td} font-semibold text-ink`}>{l.name || "—"}</td>
              <td className={td}>{l.business_name || "—"}</td>
              <td className={td}>
                <a href={`mailto:${l.email}`} className="text-mint hover:underline">{l.email}</a>
              </td>
              <td className={`${td} whitespace-nowrap`}>{l.phone || "—"}</td>
              <td className={`${td} whitespace-nowrap`}>
                {l.volume_range || (l.monthly_volume ? `${fmtMoney(l.monthly_volume)} (calc)` : "—")}
              </td>
              <td className={td}>{campaign(l)}</td>
              <td className={td}>{l.source || "hero_form"}</td>
            </tr>
          ))}
          {leads.length === 0 && (
            <tr>
              <td colSpan={8} className="px-4 py-10 text-center text-sm text-ink/40">
                No leads yet — they will appear here as soon as the first form is submitted.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </section>
);
